/** Earliest selectable date for a hearing date picker: the day after lookupDate, or tomorrow — whichever is later. */
export const getMinDate = (lookupDate) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  if (!lookupDate) return tomorrow;

  const dayAfterLookup = new Date(lookupDate);
  dayAfterLookup.setDate(dayAfterLookup.getDate() + 1);
  dayAfterLookup.setHours(0, 0, 0, 0);

  return dayAfterLookup > tomorrow ? dayAfterLookup : tomorrow;
};
